export const ROOT = 'basic-swiper';

export const CHILD = 'basic-swiper/swiper-slide';
